export default __webpack_public_path__ + "static/media/gallery_05.26d5a750.jpg";